import React from "react";

function HarmonyPage({ harmDirections, harmColors, harmIndustries, harmRhythm, _narratives,
  yongElem, userCredentials, reportNumber, setPage, lang, juvenile }) {
  return (
    <div className="lr2-page" id="ch6">
      <div className="lr2-ph">
        <span className="lr2-ph-num">06</span>
        <div>
          <div className="lr2-ph-title">能量调和建议</div>
          <div className="lr2-ph-sub">HARMONIZATION · ENVIRONMENT · LIFESTYLE</div>
        </div>
      </div>
      <div className="lr2-hgrid">
        <div className="lr2-hcard">
          <div className="lr2-htitle">🧭 方位 · 居所</div>
          <ul className="lr2-hlist">
            {harmDirections.map((it,i)=>(<li key={i}><span className="lr2-hkey">{it.key}</span><span>{it.text}</span></li>))}
          </ul>
        </div>
        <div className="lr2-hcard">
          <div className="lr2-htitle">🎨 颜色 · 材质</div>
          <ul className="lr2-hlist">
            {harmColors.map((it,i)=>(<li key={i}><span className="lr2-hkey">{it.key}</span><span>{it.text}</span></li>))}
          </ul>
        </div>
        <div className="lr2-hcard">
          <div className="lr2-htitle">{juvenile ? "📚 专业方向" : "💼 适宜行业"}</div>
          <ul className="lr2-hlist">
            {harmIndustries.map((it,i)=>(<li key={i}><span className="lr2-hkey">{it.key}</span><span>{it.text}</span></li>))}
          </ul>
        </div>
        <div className="lr2-hcard">
          <div className="lr2-htitle">⚡ 生活节律</div>
          <ul className="lr2-hlist">
            {harmRhythm.map((it,i)=>(<li key={i}><span className="lr2-hkey">{it.key}</span><span>{it.text}</span></li>))}
          </ul>
        </div>
      </div>
      <div className="lr2-dawn">
        <strong>晨曦金提示：</strong>能量调和不是一次性改变，而是持续的方向校准。每月月初花 10 分钟对照本报告的喜用神方向，评估上个月的"补给与消耗"平衡——这是澄光能量框架最简单也最有效的实践。
      </div>
      {_narratives?.harmony_advice && (
        <div className="lr2-section" style={{marginTop:18}}>
          <div className="lr2-st">个性化调和建议</div>
          <div style={{fontSize:"13.5px",color:"#333",lineHeight:1.9}}>
            {_narratives.harmony_advice.split("\n").filter(Boolean).map((para,i)=>(
              <p key={i} style={{marginBottom:10}}>{para}</p>
            ))}
          </div>
        </div>
      )}
      <div className="lr2-vajra" style={{marginTop:24}}>
        {(() => {
          const V = {
            "水": "度母法会（补水润木）", "木": "禅修共修（木气生发）",
            "火": "大圆满开示（火行调伏）", "土": "藏医养生（土行中和）",
            "金": "普巴净障（金行疏通）"
          };
          const ev = V[yongElem] || V["水"];
          return (<>
            <div className="lr2-vajra-head">
              <span className="lr2-vajra-icon">☸</span>
              <div>
                <div className="lr2-vajra-title">深度修持 · 内在能量通道</div>
                <div className="lr2-vajra-sub">你的用神为{yongElem||"水"} · {ev}天然共振</div>
              </div>
            </div>
            <div className="lr2-vajra-body">
              <p>环境调整是外在能量布局。内在能量通道的疏通，才是根本性的转化。</p>
              <p>对应到你的命盘——用神{yongElem||"水"}方向的法会（{ev}）是最直接的共振入口。所有内容免费开放，不强制、不要求信仰背景。</p>
            </div>
          </>);
        })()}
        <div className="lr2-vajra-tz">🕐 法会时间标注 America/Toronto · ET · 北京时间 · BST 四时区</div>
        <button className="lr2-vajra-cta" onClick={()=>setPage&&setPage("vajra")}>查看法会日历 · 报名参加 →</button>
      </div>
      {userCredentials.length > 0 && (
        <div className="lr2-cred">
          <div className="lr2-cred-title">☸ 修行资质档案 · 与报告关联</div>
          <div className="lr2-cred-sub">数据来自您的 Vajra Portal 修行记录</div>
          {userCredentials.slice(0,4).map((c,i)=>{
            const pct = c.progress_pct ?? c.pct ?? 50;
            return (
              <div key={i} className="lr2-cred-item">
                <div className="lr2-cred-head">
                  <span className="lr2-cred-name">{c.label_zh || c.name || c.credential_key || "—"}</span>
                  <span className="lr2-cred-pct">{Math.round(pct)}%</span>
                </div>
                <div className="lr2-cred-track"><div className="lr2-cred-fill" style={{width:pct+"%"}}/></div>
              </div>
            );
          })}
          <div style={{fontSize:12,color:"#6D28D9",marginTop:12,fontFamily:"sans-serif",opacity:.7}}>本报告编号 {reportNumber} 将与您的修行档案关联</div>
        </div>
      )}
      <div className="lr2-pf"><span className="lr2-pf-label">澄光能量 · {reportNumber}</span><span className="lr2-pf-seal lr2-pf-current">6</span></div>
    </div>
  );
}

export default HarmonyPage;
